import React from "react";
import { Link } from "gatsby";

import fr from "../../images/fr.png";
import en from "../../images/en.png";

import { languages, getLocalizedPath } from "../../i18n";

import { PageContext } from "../../pageContext";



const flags = {
    fr,
    en
};


const LanguageSwitcher = () => (
        <PageContext.Consumer>
            {({originalPath, locale}) => (

                <div className="dropdown">
                    <button className="btn dropdown-toggle text-uppercase" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        {locale} &nbsp; <i className="fa fa-angle-down"></i>
                    </button>
                    <div style={{minWidth: '50px'}} className="dropdown-menu text-uppercase" id="change-lang"
                         aria-labelledby="dropdownMenuButton">
                        {
                            languages.map(lang =>

                                <Link
                                    className="dropdown-item"
                                    key={lang.locale}
                                    to={getLocalizedPath(originalPath, lang.locale)}
                                    //onClick={() => setLang(lang.locale)}
                                >{lang.locale}

                                </Link>
                            )
                        }
                    </div>
                </div>
            )}
        </PageContext.Consumer>

);

export default LanguageSwitcher;
